import { BusinessReportArray } from './BusinessReportGetResponse';
import { BusinessReportPutRequest } from './BusinessReportPutRequest';

export interface BusinessReportModalView {
  id: number;
  date: string; // "YYYY-MM-DD"
  projectId: number;
  projectNo: string;
  projectName: string;
  manHoursA: boolean;
  manHoursB: boolean;
  manHoursC: boolean;
  manHoursD: boolean;
  manHoursE: boolean;
  startTime: string; // "HH:mm"
  endTime: string; // "HH:mm"
  manHoursTotal: number; // 0.5刻み
}

export const toBusinessReportModalView = (
  item: BusinessReportArray | BusinessReportPutRequest
): BusinessReportModalView => {
  return {
    id: item.id,
    date: item.date,
    projectId: item.projectId,
    projectNo: item.projectNo,
    projectName: item.projectName,
    manHoursA: item.manHoursCategory === 'A',
    manHoursB: item.manHoursCategory === 'B',
    manHoursC: item.manHoursCategory === 'C',
    manHoursD: item.manHoursCategory === 'D',
    manHoursE: item.manHoursCategory === 'E',
    startTime: item.startTime,
    endTime: item.endTime,
    manHoursTotal: item.manHoursTotal,
  };
};
